module.exports = __webpack_public_path__ + "img/user-interviews.635c7d4b.png";